module.exports = __webpack_public_path__ + "img/demo2.801bb757.png";